import axios from "axios";
import { differenceInMilliseconds, subMinutes } from "date-fns";
import { authActionsType } from "./reducer";

export interface ISystemAuthDispatch {
  type: string;
  error?: any;
}


export async function loginUser(dispatch: React.Dispatch<any> | null, loginPayload: string) {
  if (dispatch) {
    try {
      dispatch({ type: "REQUEST_LOGIN" });

      //console.log("loggin requested ", loginPayload);

      if (loginPayload) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${loginPayload}`;

        refreshToken(dispatch);
      }
    } catch (error) {
      dispatch({ type: "LOGIN_ERROR", error: error });
      //console.log(error);
    }
  } else {
    console.log("dispatch is null");
  }
}

export async function setUserId(dispatch: React.Dispatch<authActionsType> | null, userId: string | null) {
  if (dispatch) dispatch({ type: "SET_USER_ID" });
  let currentUser = localStorage.getItem('currentUser')
	? JSON.parse(localStorage.getItem('currentUser') || "") : null;

  localStorage.setItem(
    "currentUser",
    JSON.stringify({ user: currentUser?.email, userId: userId, auth_token: currentUser?.token, token_expires: Date.parse(currentUser?.tokenExpires)?.toString() })
  );
  if (dispatch) dispatch({     
    type: "SET_USER_ID",
    userId : userId,
});


}

export async function logout(dispatch: React.Dispatch<any> | null) {
  if (dispatch) dispatch({ type: "LOGOUT" });
  localStorage.removeItem("currentUser");
  localStorage.removeItem("customerToken");
  localStorage.removeItem("SystemTokenExpires");
}

export async function setConnection(dispatch: React.Dispatch<any> | null, connectionPayload: signalR.HubConnection | null) {
  if (dispatch) dispatch({     
    type: "SET_CONNECTION",
    connection : connectionPayload,
});
}

export async function refreshToken(dispatch: React.Dispatch<any> | null) {
  if (dispatch) {
    await axios
      .get(`/api/v1/Account/refresh`)
      .then((res) => {
        localStorage.setItem(
          "currentUser",
          JSON.stringify({ user: res.data.email, userId: res.data.userId, auth_token: res.data.token, token_expires: Date.parse(res.data.tokenExpires).toString() })
        );
        dispatch({
          type: "LOGIN_SUCCESS",
          payload: {
            user: { user: res.data.email, token: res.data.data, tokenExpires: Date.parse(res.data.tokenExpires)?.toString() },
            auth_token: res.data.token,
          },
        });

        if (res.data.tokenExpires) {
          let timeoutDateTime = Date.parse(res.data.tokenExpires);

          //Refresh token 5 minutes before expiration
          scheduleExecution(subMinutes(timeoutDateTime, 5), function () {
            refreshToken(dispatch);
          });
        }
        //SystemTokenExpires
        localStorage.setItem("SystemTokenExpires", Date.parse(res.data.tokenExpires)?.toString());
        return { user: res.data.userId, auth_token: res.data.token, token_expires: Date.parse(res.data.tokenExpires)?.toString() };
      })
      .catch((error) => {
        dispatch({ type: "LOGIN_ERROR", error });
        console.log("Refresh error", error);
        return;
      });
  }
}



export function scheduleExecution(futureDate: Date, callback: () => void) {
  var now = new Date();
  setTimeout(callback, differenceInMilliseconds(futureDate, now));
}
